import { Pipe, LOCALE_ID, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray, AbstractControl } from '@angular/forms';
import { Vendor } from '@models/vendor';
import { Store } from '@models/store';
import { Order } from '@models/order';
import { Product, ProductQuery, ProductElement, FrameDetails, LensDetails, FrameMeasurements } from '@models/product';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTable, MatTableModule } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { environment } from '@environments/environment';
import { AuthService } from '@services/auth.service';

export class ProductForm {

  constructor() {
    // this.orderForm = fb.group({
  //     orders: this.fb.array([])
  //   });
  }

  static initProductFormArray(products:Product[], auth: AuthService, storeOptions: any[]) {
    let fb = new FormBuilder();
    let productFormArray:FormArray = fb.array([]);
    for (var x = 0; x < products.length; x++) {
      let productFormGroup = ProductForm.initProductFormGroup(products[x]);
      productFormArray.push(productFormGroup);
    }
    return productFormArray;
  }

  static initProductElementFormGroup(productElement:ProductElement) {
    let fb = new FormBuilder();
    let productFormGroup = ProductForm.initProductFormGroup(
      productElement?.product || ({} as Product)
    );
    let frameFormGroup = ProductForm.initProductElementFrameFormGroup(
      productElement?.frame
    );
    let lensFormGroup = ProductForm.initProductElementLensFormGroup(productElement?.lens);
    let productElementFormGroup:FormGroup = fb.group({
        '_id': productElement._id,
        'cost': productElement.cost,
        'tax': productElement.tax,
        'shipping': productElement.shipping,
        'custom': productElement.custom,
        'lensesPrice': productElement.lensesPrice,
        'tintPrice': productElement.tintPrice,
        'coatingsPrice': productElement.coatingsPrice,
        'miscPrice': productElement.miscPrice,
        'subtotal': productElement.subtotal,
        'pricingFormula': productElement.pricingFormula,
        'retail': productElement.retail,
        'duty': [{value:productElement.duty, disabled: true}],
        'dutyAmount': productElement.dutyAmount || 0,
        'costOriginal': productElement.costOriginal,
        'costCurrency': productElement.costCurrency || 'USD',
        'costExchangeRate': productElement.costExchangeRate,
        'costConvertedAt': productElement.costConvertedAt,
        'costUsdOverridden': productElement.costUsdOverridden || false,
        'quantity': productElement.quantity,
        'frame': frameFormGroup,
        'lens': lensFormGroup,
        'product': productFormGroup,
        'store': productElement.store,
        'type': productElement.type,
        'destination': productElement.destination
      });
    return productElementFormGroup;
  }

  static initProductFormGroup(product:Product) {
    let fb = new FormBuilder();
    if (!product) {
      product = {} as Product;
    }
    product.notes = product.notes;
    product.images = (Array.isArray(product.images)) ? product.images : [];
    product.inventoryVendorOrders = (Array.isArray(product.inventoryVendorOrders)) ? product.inventoryVendorOrders : [];
    let tmpProduct = Object.assign({}, product);
    let vendorFormGroup;
    if (tmpProduct.vendor) {
      if (Array.isArray(tmpProduct.vendor)) {
        tmpProduct.vendor = tmpProduct.vendor[0];
      }
      if (typeof tmpProduct.vendor === "object") {
        // vendorFormGroup = this.initVendorFormGroup(tmpProduct.vendor as Vendor);
        vendorFormGroup = fb.control(tmpProduct.vendor as Vendor);
      } else {
        vendorFormGroup = fb.control(tmpProduct.vendor);
      }
      product.vendor = null;
    }

    let imageArray: FormControl = fb.control(tmpProduct.images);
    product.images = null;

    let borrowingArray: FormControl = fb.control(tmpProduct.borrowing);
    product.borrowing = null;

    let inventoryVendorOrdersArray: FormControl = fb.control(tmpProduct.inventoryVendorOrders);
    product.inventoryVendorOrders = null;

    let vendorControl: FormControl = fb.control(null);

    product.return = false;
    let productFormGroup = fb.group(product);
    productFormGroup.removeControl('images');
    productFormGroup.removeControl('borrowing');
    productFormGroup.removeControl('vendor');
    productFormGroup.removeControl('inventoryVendorOrders');

    productFormGroup.addControl('images', imageArray);
    productFormGroup.addControl('borrowing', borrowingArray);
    productFormGroup.addControl('inventoryVendorOrders', inventoryVendorOrdersArray);
    if (vendorFormGroup) {
      productFormGroup.addControl('vendor', vendorFormGroup);
    } else {
      productFormGroup.addControl('vendor', vendorControl);
    }

    if (tmpProduct.vendor) {
      productFormGroup.removeControl('vendor');
      productFormGroup.addControl('vendor', vendorFormGroup);
      product.vendor = tmpProduct.vendor;
    }

let cont = fb.control(false);
    productFormGroup.addControl('return', cont);

    const costGroup = productFormGroup as FormGroup;
    if (!costGroup.get('costOriginal')) {
      costGroup.addControl('costOriginal', fb.control(product.costOriginal ?? null));
    }
    if (!costGroup.get('costCurrency')) {
      costGroup.addControl('costCurrency', fb.control(product.costCurrency || 'USD'));
    }
    if (!costGroup.get('costExchangeRate')) {
      costGroup.addControl('costExchangeRate', fb.control(product.costExchangeRate ?? null));
    }
    if (!costGroup.get('costConvertedAt')) {
      costGroup.addControl('costConvertedAt', fb.control(product.costConvertedAt ?? null));
    }
    if (!costGroup.get('costUsdOverridden')) {
      costGroup.addControl('costUsdOverridden', fb.control(!!product.costUsdOverridden));
    }

    productFormGroup.addControl('query', fb.control(new ProductQuery()));
    productFormGroup.addControl('queryProducts', fb.control({model: [], color: [], size: [], type: []}));

    product.images = tmpProduct.images;
    product.borrowing = tmpProduct.borrowing;

    return productFormGroup;
  }

  static initProductElementFrameFormGroup(frame:FrameDetails) {
    let fb = new FormBuilder();
    if (!frame) {
      frame = {} as FrameDetails;
    }
    let measurementsFormGroup = ProductForm.initProductElementFrameMeasurementsFormGroup(frame.measurements);
    let productElementFrameFormGroup: FormGroup = fb.group({
      frameSource: frame.frameSource,
      measurements: measurementsFormGroup,
      enclosed: frame.enclosed,
      pof: frame.pof,
      patientToSupply: frame.patientToSupply,
      duty: frame.duty,
      hold: frame.hold,
      modification: frame.modification,
      modificationPrice: frame.modificationPrice,
      modificationDetails: frame.modificationDetails,
      estimate: frame.estimate,
      deposit: frame.deposit,
      callPatient: frame.callPatient,
      notes: frame.notes ?? '',
      price: frame.price,
      orderDate: frame.orderDate,
      dueDate: frame.dueDate,
      failedInspection: frame.failedInspection,
      approved: frame.approved,
      nosepadInstall: frame.nosepadInstall,
      preOrderStatus: frame.preOrderStatus ?? '',
      dateReceived: frame.dateReceived ?? '',
      followUpStatus: frame.followUpStatus ?? '',
      followUpDate: frame.followUpDate ?? '',
      partOther: frame.partOther ?? false,
      partOtherDescription: frame.partOtherDescription ?? '',
      partOtherPrice: frame.partOtherPrice ?? null,
      material: frame.material ?? '',
      materialPrice: frame.materialPrice ?? null,
      referenceNumber: frame.referenceNumber ?? '',
      physicalStatus: frame.physicalStatus ?? '',
      activityStatus: frame.activityStatus ?? '',
      carrier: frame.carrier ?? '',
      trackingNumber: frame.trackingNumber ?? '',
      shipDate: frame.shipDate ?? '',
      labVendor: frame.labVendor ?? '',
      etaChecked: !!frame.etaChecked,
      etaCheckedBy: frame.etaCheckedBy ?? '',
      etaCheckedAt: frame.etaCheckedAt ?? '',
      repairItems: fb.control(
        Array.isArray(frame.repairItems) ? frame.repairItems : []
      ),
      activity: fb.array(
        (Array.isArray(frame.activity) ? frame.activity : []).map((entry) =>
          fb.group({
            id: entry?.id ?? '',
            kind: entry?.kind ?? '',
            date: entry?.date ?? '',
            status: entry?.status ?? '',
            branch: entry?.branch ?? '',
            notes: entry?.notes ?? '',
            repairItems: [Array.isArray(entry?.repairItems) ? entry.repairItems : []],
            waitingOn: entry?.waitingOn ?? '',
            vendor: entry?.vendor ?? '',
            followUpDate: entry?.followUpDate ?? '',
            expectedDate: entry?.expectedDate ?? '',
            followUpNumber: entry?.followUpNumber ?? 0,
            activityChoice: entry?.activityChoice ?? '',
            reopenedFrom: entry?.reopenedFrom ?? '',
            sourceId: entry?.sourceId ?? '',
            description: entry?.description ?? '',
            referenceNumber: entry?.referenceNumber ?? '',
            carrier: entry?.carrier ?? '',
            trackingNumber: entry?.trackingNumber ?? '',
            labVendor: entry?.labVendor ?? '',
            repairLocation: entry?.repairLocation ?? '',
            estimate: entry?.estimate ?? '',
            price: entry?.price ?? '',
            estimateApprovalRequired: !!entry?.estimateApprovalRequired,
            approvalStatus: entry?.approvalStatus ?? '',
            otherText: entry?.otherText ?? '',
            whoToCall: entry?.whoToCall ?? '',
            images: [Array.isArray(entry?.images) ? entry.images : []],
            eta: entry?.eta ?? '',
            completed: !!entry?.completed,
            completedBy: entry?.completedBy ?? '',
            completedAt: entry?.completedAt ?? '',
          })
        )
      ),
    });
    return productElementFrameFormGroup;
  }

  static initProductElementFrameMeasurementsFormGroup(frameMeasurements:FrameMeasurements) {
    let fb = new FormBuilder();
    const measurements = frameMeasurements || ({} as FrameMeasurements);
    let productElementFrameMeasurementsFormGroup:FormGroup = fb.group({
        a: measurements.a,
        b: measurements.b,
        ed: measurements.ed,
        dbl: measurements.dbl
      });
    return productElementFrameMeasurementsFormGroup;
  }

  static initProductElementLensFormGroup(lens:LensDetails) {
    if (!lens) lens = new LensDetails();
    let fb = new FormBuilder();
    let productElementLensFormGroup:FormGroup = fb.group({
        'bc': lens.bc,
        'et': lens.et,
        'ct': lens.ct,
        'lab': lens.lab,
        'type': lens.type,
        'material': lens.material,
        'transition': lens.transition,
        'polar': lens.polar,
        'design': lens.design,
        'tint': lens.tint,
        'coating': lens.coating,
        'overPowerSph': lens.overPowerSph,
        'edgePolish': lens.edgePolish,
        'mountingEdging': lens.mountingEdging,
        'prism': lens.prism,
        'overPowerCyl': lens.overPowerCyl,
        'bevel': lens.bevel,
        'drill': lens.drill,
        'backsideAR': lens.backsideAR,
        'specialBC': lens.specialBC,
        'specialTool': lens.specialTool,
        'groove': lens.groove,
        'sendForAR': lens.sendForAR,
        'UVcoating': lens.UVcoating,
        'slabOff': lens.slabOff,
        'mirror': lens.mirror,
        'mirrorDetails': lens.mirrorDetails,
        'customShape': lens.customShape,
        'other': lens.other,
        'otherDetails': lens.otherDetails,
        'otherPrice': lens.otherPrice,
        'price': lens.price,
        'POL': lens.POL,
        'POLLabReferenceNumber': lens.POLLabReferenceNumber,
        'POLPrice': lens.POLPrice,
        'taxable': lens.taxable,
        'lensAndShapeNotes': lens.lensAndShapeNotes,
        'machine': lens.machine,
        'grooveSize': lens.grooveSize,
        'lensSize': lens.lensSize,
        'depth': lens.depth,
        'bevel2': lens.bevel2,
        'width': lens.width,
        'placement': lens.placement,
        'technicalNotes': lens.technicalNotes,
        'date': lens.date,
        'labReferenceNumber': lens.labReferenceNumber,
        'failedInspection': lens.failedInspection
      });
    return productElementLensFormGroup;
  }

  static togglePriceLink(productsForm: FormGroup, product: FormGroup, editProduct:FormGroup, vendor: Vendor, index) {
    let saveProduct = false;
    if (product.value.pricingFormula == 'c') {
      // let currentVendor: Vendor = product.get('vendor').value as Vendor;
      // currentVendor.pricingFormulaOptical = vendor.pricingFormulaOptical;
      // currentVendor.pricingFormulaSun = vendor.pricingFormulaSun;
      // product.get('vendor').setValue(currentVendor);
      // product.controls.pricingFormula.setValue((product.value.type == 'RX') ? product.value.vendor.pricingFormulaOptical : product.value.vendor.pricingFormulaSun);
      product.controls.pricingFormula.setValue((product.value.type == 'RX') ? vendor.pricingFormulaOptical : vendor.pricingFormulaSun);
      product.controls.retail.setValue(Product.calculateProductPrice(product.value));
      let arr:FormArray = <FormArray>productsForm.controls['productsFormArray'];
      let control:FormGroup = <FormGroup>arr.controls[index];
      control.controls.retail.setValue(product.value.retail);
      if (!editProduct || editProduct && editProduct.value._id != product.value._id) {
        saveProduct = true;
      }
    } else {
      product.controls.pricingFormula.setValue('c');
    }
    return saveProduct;
  }

  static calculateProductPrice(product: Product) {
    let rx_validate = /^x.+p.+$/;
    let rx_extract = /^x(.+)p(.+)$/;
    let result = [];
    let multiplier = 1;
    let adder = 0;
    if (rx_validate.test(product.pricingFormula)) {
      result = rx_extract.exec(product.pricingFormula);
      multiplier = parseFloat(result[1]);
      adder = parseFloat(result[2]);
    }
    if (parseFloat(product.cost.toString())) {
      return Math.ceil((Math.round((parseFloat(product.cost.toString()) * multiplier + adder) * 100) / 100)/5)*5;
    }
    return null;
  }

  static vendorDuty(vendor: Vendor, isOrder: boolean): number {
    if (!isOrder || !vendor?.dutyEnabled) {
      return 0;
    }
    const amount = parseFloat(String(vendor.dutyAmountPerFrame ?? 0));
    return isNaN(amount) || amount < 0 ? 0 : amount;
  }

  static writeDuty(product: FormGroup, duty: number): void {
    if (!product.get('dutyAmount')) {
      product.addControl('dutyAmount', new FormControl(0));
    }
    product.get('dutyAmount').setValue(duty || 0, { emitEvent: false });
    const flag = product.get('duty');
    if (flag && duty > 0 && !flag.value) {
      if (flag.disabled) {
        flag.enable({ emitEvent: false });
      }
      flag.setValue(true, { emitEvent: false });
    }
  }

  static linkedRetail(product: Product, duty: number): number | null {
    const base = Product.calculateProductPrice(product);
    if (base == null) {
      return null;
    }
    return base + (duty || 0);
  }

  static changeRetail(product: FormGroup, vendor: Vendor, isOrder: boolean = false) {
    // let currentVendor: Vendor = (!isOrder) ? product.get('vendor').value as Vendor : vendor;
    // currentVendor.pricingFormulaOptical = vendor.pricingFormulaOptical;
    // currentVendor.pricingFormulaSun = vendor.pricingFormulaSun;
    if (!isOrder) {
      // product.get('vendor').setValue(currentVendor);
    }
    // product.get('pricingFormula').setValue((product.value.type == 'RX') ? currentVendor.pricingFormulaOptical : currentVendor.pricingFormulaSun);
    product.get('pricingFormula').setValue((product.value.type == 'RX') ? vendor.pricingFormulaOptical : vendor.pricingFormulaSun);
    const duty = ProductForm.vendorDuty(vendor, isOrder);
    let calculatedRetail = ProductForm.linkedRetail(product.value, duty);
    if (calculatedRetail != product.get('retail').value) {
      product.get('pricingFormula').setValue('c');
    }
  }

  static changeCost(product: FormGroup, vendor: Vendor, isOrder: boolean = false) {
    let pricingFormulaControl = product.get('pricingFormula');
    // let currentVendor: Vendor = (!isOrder) ? product.get('vendor').value as Vendor : vendor;
    // console.log(currentVendor)
    // console.log(vendor)
    // console.log(product)
    if (pricingFormulaControl.value != 'c') {
      // currentVendor.pricingFormulaOptical = vendor.pricingFormulaOptical;
      // currentVendor.pricingFormulaSun = vendor.pricingFormulaSun;
      if (!isOrder) {
        // product.get('vendor').setValue(currentVendor);
        // product.get('vendor').setValue(vendor);
      }
      // pricingFormulaControl.setValue((product.value.type == 'RX') ? currentVendor.pricingFormulaOptical : currentVendor.pricingFormulaSun);
      pricingFormulaControl.setValue((product.value.type == 'RX') ? vendor.pricingFormulaOptical : vendor.pricingFormulaSun);
      const duty = ProductForm.vendorDuty(vendor, isOrder);
      if (isOrder) {
        ProductForm.writeDuty(product, duty);
      }
      product.get('retail').setValue(ProductForm.linkedRetail(product.value, duty));
    }
  }

}
